var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.97 45.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.63 20.89 59.96 0 47.34 9.46 44.7 18.18 53.63 20.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.58,
    y: 21.33,
    width: 11.25,
    height: 9.34,
    transform: "translate(8.63 63.64) rotate(-73.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.71 33.83 47.29 41.81 37.54 41.81 40.78 31.12 49.71 33.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.65 41.81 34.65 32.29 29.98 24.13 25.31 32.29 25.31 41.81 34.65 41.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.33 20.89 0 0 12.62 9.46 15.27 18.18 6.33 20.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.09,
    y: 20.38,
    width: 9.34,
    height: 11.25,
    transform: "translate(-6.99 4.82) rotate(-16.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.42 41.81 12.67 41.81 10.25 33.83 19.19 31.12 22.42 41.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.48 25.98 30.04 13.38 18.86 27.84 19.38 29.47 19.62 30.2 29.92 17.16 38.19 29.49 41.77 25.56 43.19 20.89 38.48 25.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.1 11.73 66 2.15 64.39 0.65 58.55 6.92 57.1 11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83,39.31A2.31,2.31,0,0,1,85.41,37H87V36a1.47,1.47,0,0,0-1.51-1.61A1.43,1.43,0,0,0,84,35.83c0,.11-.07.16-.16.16h-.6a.15.15,0,0,1-.16-.16,2.39,2.39,0,1,1,4.78.13v3.35a2.46,2.46,0,1,1-4.91,0Zm4,0V37.88H85.41a1.42,1.42,0,0,0-1.52,1.43,1.48,1.48,0,0,0,1.55,1.61A1.47,1.47,0,0,0,87,39.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.49,41.49V36a2.39,2.39,0,1,1,4.78,0v5.5a.15.15,0,0,1-.16.16h-.6a.15.15,0,0,1-.16-.16V36a1.48,1.48,0,1,0-2.95,0v5.5a.15.15,0,0,1-.16.16h-.59A.15.15,0,0,1,89.49,41.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.76,39.31A2.31,2.31,0,0,1,98.2,37h1.56V36a1.48,1.48,0,0,0-1.51-1.61,1.44,1.44,0,0,0-1.45,1.48c0,.11-.06.16-.16.16h-.59a.15.15,0,0,1-.16-.16,2.33,2.33,0,0,1,2.36-2.36A2.35,2.35,0,0,1,100.67,36v3.35a2.46,2.46,0,1,1-4.91,0Zm4,0V37.88H98.2a1.42,1.42,0,0,0-1.53,1.43,1.55,1.55,0,1,0,3.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.43,41.49V30.58a.16.16,0,0,1,.16-.16h.6a.16.16,0,0,1,.16.16V41.49a.15.15,0,0,1-.16.16h-.6A.15.15,0,0,1,102.43,41.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.12,33.79V42.5A2.35,2.35,0,0,1,107.68,45a2.42,2.42,0,0,1-2.44-2.52.16.16,0,0,1,.16-.16h.6a.15.15,0,0,1,.16.16,1.48,1.48,0,0,0,1.52,1.64,1.46,1.46,0,0,0,1.53-1.64V40.68a2,2,0,0,1-1.53.81A2.38,2.38,0,0,1,105.24,39V33.79a.16.16,0,0,1,.16-.16h.6a.16.16,0,0,1,.16.16V39a1.53,1.53,0,1,0,3,0V33.79a.15.15,0,0,1,.16-.16H110A.15.15,0,0,1,110.12,33.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.19,41v.57a.15.15,0,0,1-.16.16h-.21c-1.43,0-2.26-1-2.26-2.7V34.5h-1a.16.16,0,0,1-.16-.16v-.55a.16.16,0,0,1,.16-.16h1V31.55a.16.16,0,0,1,.16-.17h.59a.16.16,0,0,1,.16.17v2.08h1.37a.16.16,0,0,1,.16.16v.55a.16.16,0,0,1-.16.16h-1.37V39c0,1.19.47,1.81,1.35,1.81H115A.15.15,0,0,1,115.19,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.42,32a.6.6,0,0,1,.63-.62.61.61,0,0,1,.63.62.63.63,0,0,1-.63.63A.61.61,0,0,1,116.42,32Zm.18,9.53v-7.7a.16.16,0,0,1,.16-.16h.6a.16.16,0,0,1,.16.16v7.7a.15.15,0,0,1-.16.16h-.6A.15.15,0,0,1,116.6,41.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.15,39.3V36a2.41,2.41,0,1,1,4.82-.16.16.16,0,0,1-.17.16h-.59a.15.15,0,0,1-.16-.16,1.45,1.45,0,0,0-1.49-1.48A1.48,1.48,0,0,0,120.07,36V39.3a1.48,1.48,0,0,0,1.52,1.63,1.55,1.55,0,0,0,1.53-1.63c0-.12.06-.17.16-.17h.59a.16.16,0,0,1,.16.17,2.44,2.44,0,0,1-2.44,2.51A2.38,2.38,0,0,1,119.15,39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,39.3a.16.16,0,0,1,.16-.17h.59c.1,0,.16,0,.16.17a1.49,1.49,0,0,0,1.66,1.63c1,0,1.44-.53,1.44-1.28,0-1.94-3.93-1.33-3.93-4a2.18,2.18,0,0,1,2.31-2.17,2.22,2.22,0,0,1,2.42,2.36.15.15,0,0,1-.16.16h-.59a.14.14,0,0,1-.16-.16,1.41,1.41,0,0,0-1.46-1.48A1.31,1.31,0,0,0,126,35.64c0,1.86,3.94,1.25,3.94,4a2.2,2.2,0,0,1-2.36,2.16A2.43,2.43,0,0,1,125,39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.21,7.52V22.77c0,3.36-1.85,5.54-4.86,5.54a4.13,4.13,0,0,1-3.54-1.88,4.1,4.1,0,0,1-3.49,1.88c-3,0-4.85-2.18-4.85-5.54V7.52a.36.36,0,0,1,.39-.39h1.87a.36.36,0,0,1,.39.39V22.89c0,1.84.77,2.89,2.2,2.89s2.18-1.05,2.18-2.89V7.52a.36.36,0,0,1,.39-.39h1.87a.36.36,0,0,1,.39.39V22.89c0,1.84.92,2.89,2.2,2.89,1.43,0,2.18-1.05,2.18-2.89V7.52a.36.36,0,0,1,.38-.39h1.88A.37.37,0,0,1,83.21,7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.29,23.48A4.4,4.4,0,0,1,90,19.11h2.23V17.47a2.07,2.07,0,0,0-2.14-2.27,2,2,0,0,0-2,2.06c0,.27-.15.36-.42.36H85.92a.39.39,0,0,1-.39-.42,4.62,4.62,0,1,1,9.23.39v6a4.42,4.42,0,0,1-4.64,4.71A4.6,4.6,0,0,1,85.29,23.48Zm6.94.09V21.4H90.09a2.06,2.06,0,0,0-2.24,2.08,2.14,2.14,0,0,0,2.24,2.36A2,2,0,0,0,92.23,23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.41,7.52V23.45a4.74,4.74,0,1,1-9.47,0V17.62c0-2.83,1.75-4.86,4.43-4.86a3.33,3.33,0,0,1,2.48,1.07V7.52a.37.37,0,0,1,.41-.39H106A.37.37,0,0,1,106.41,7.52Zm-2.56,10a2.19,2.19,0,1,0-4.38,0v6a2.19,2.19,0,1,0,4.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.17,13.09a.37.37,0,0,1,.42.39V23.54a2.1,2.1,0,1,0,4.17,0V13.48a.37.37,0,0,1,.42-.39h1.72a.37.37,0,0,1,.42.39v10a4.65,4.65,0,1,1-9.29,0v-10a.37.37,0,0,1,.42-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.49,23.48a4.4,4.4,0,0,1,4.71-4.37h2.23V17.47a2.07,2.07,0,0,0-2.14-2.27,2,2,0,0,0-2,2.06c0,.27-.14.36-.41.36h-1.73a.39.39,0,0,1-.39-.42,4.62,4.62,0,1,1,9.24.39v6a4.43,4.43,0,0,1-4.65,4.71A4.6,4.6,0,0,1,120.49,23.48Zm6.94.09V21.4h-2.14a2.05,2.05,0,0,0-2.23,2.08,2.13,2.13,0,0,0,2.23,2.36A2,2,0,0,0,127.43,23.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc02fb869432e376cadd7bb12b419942.svg";
export { ForwardRef as ReactComponent };